export default __webpack_public_path__ + "static/media/google-gmail.4b8ce376.svg";